module.exports = __webpack_public_path__ + "static/mstile-150x150.f985818b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Favicon/mstile-150x150.png
// module id = 698
// module chunks = 114276838955818